import * as actionTypes from "./actionTypes";

const initialPagination = { optional: 0 };

const initialState = {
  fetchUSBDetectionLoading: true,
  USBDetectionData: [],
  pagination: initialPagination,
  USBDetectionErrorMessage: "",
  downloadUSBDetectionLoading: false,
  fetchUSBDetectionReportLoading: true,
  USBDetectionReportData: [],
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case actionTypes.FETCH_USB_DETECTION:
      return {
        ...state,
        fetchUSBDetectionLoading: true,
        USBDetectionErrorMessage: "",
      };

    case actionTypes.FETCH_USB_DETECTION_SUCCESS: {
      
      return {
        ...state,
        fetchUSBDetectionLoading: false,
        USBDetectionData: action.payload.data,
        pagination: action.payload.optional || state.pagination,
      };
    }

    case actionTypes.FETCH_USB_DETECTION_FAILED:
      return {
        ...state,
        fetchUSBDetectionLoading: false,
        USBDetectionData: [],
        pagination: initialPagination,
        USBDetectionErrorMessage: action.payload,
      };

    case actionTypes.FETCH_USB_DETECTION_REPORT:
      return {
        ...state,
        fetchUSBDetectionReportLoading: true,
        USBDetectionErrorMessage: "",
      };

    case actionTypes.FETCH_USB_DETECTION_REPORT_SUCCESS: {
      return {
        ...state,
        fetchUSBDetectionReportLoading: false,
        USBDetectionReportData: action.payload.data,
        pagination: action.payload || state.pagination,
      };
    }

    case actionTypes.FETCH_USB_DETECTION_REPORT_FAILED:
      return {
        ...state,
        fetchUSBDetectionReportLoading: false,
        USBDetectionReportData: [],
        pagination: initialPagination,
        USBDetectionErrorMessage: action.payload,
      };
    case actionTypes.DOWNLOAD_USB_DETECTION:
      return {
        ...state,
        downloadUSBDetectionLoading: true,
        USBDetectionErrorMessage: "",
      };

    case actionTypes.DOWNLOAD_USB_DETECTION_SUCCESS:
      return {
        ...state,
        downloadUSBDetectionLoading: false,
      };

    case actionTypes.DOWNLOAD_USB_DETECTION_FAILED:
      return {
        ...state,
        downloadUSBDetectionLoading: false,
        USBDetectionErrorMessage: action.payload,
      };

    case actionTypes.DOWNLOAD_USB_DETECTION_REPORT:
      return {
        ...state,
        downloadUSBDetectionReportLoading: true,
        USBDetectionErrorMessage: "",
      };

    case actionTypes.DOWNLOAD_USB_DETECTION_REPORT_SUCCESS:
      return {
        ...state,
        downloadUSBDetectionReportLoading: false,
      };

    case actionTypes.DOWNLOAD_USB_DETECTION_REPORT_FAILED:
      return {
        ...state,
        downloadUSBDetectionReportLoading: false,
        USBDetectionErrorMessage: action.payload,
      };

    default:
      return state;
  }
};
